// Factories
import { BaseWorkerFactory } from "../../base/factories/BaseWorkerFactory";
/**
 * Factory class for worker providers in Teams app
 */
export class TeamsWorkerFactory extends BaseWorkerFactory {
}
